import { styled as o, Box as c, Typography as p } from "@mui/material";
import a from "../../temp-lib/components/share/apeiron/ApeironBlueButton.js";
import { useAccountContext as l } from "../../temp-lib/contexts/account/AccountContext.js";
import * as d from "ramda";
import { useCallback as m } from "react";
import { useTranslation as u } from "react-i18next";
import { jsxs as f, jsx as r } from "react/jsx-runtime";
const x = o(c)`
  align-items: center;
  background-color: #33333333;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 12px 125px;
`, g = o(a)`
  --background-color: #00000099;
  border-radius: 4px;
  border: 2px solid #005bd7cc;
  font-weight: 400;
  height: unset;
  letter-spacing: 0.25px;
  min-height: unset;
  padding: 10px 50px;
`, h = o(p)`
  color: #ffffffaa;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.25px;
`, L = (e) => {
  const {
    remark: t
  } = e, {
    setShowLoginPopup: n
  } = l(), {
    t: i
  } = u(), s = m(() => {
    n(!0);
  }, [n]);
  return /* @__PURE__ */ f(x, {
    children: [d.isNotNil(t) && /* @__PURE__ */ r(h, {
      children: t
    }), /* @__PURE__ */ r(g, {
      onClick: s,
      children: i("common.login_to_check")
    })]
  });
};
export {
  L as default
};
//# sourceMappingURL=LoginRequestButton.js.map
